var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-image',{style:({ width: _vm.width, height: _vm.auto ? 'auto' : _vm.width }),attrs:{"src":_vm.fullSrc,"preview-src-list":_vm.viewList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }